export default {
  authToken: null,
  user: {},
};
